<div *ngIf="user" class="offset-7 col-md-4 col-lg-4" style="text-align:right;margin-top: 5px;">
    <button (click)="goToHomePage()" title="Home" aria-label="Home">
      <img alt="homeIcon" src="../assets/icons/home.svg" height="50" width="50">

      <figcaption style="padding:0px;text-align: center;font-weight: bold;"> Home </figcaption>
    </button>
    
  </div>
<h3 style="color:red;text-align: center;">The resource you are looking for was not found</h3>
